<template>
  <ul 
    class="menu" 
    :class="mode"
  >
    <div
      v-for="link in links"
      :id="link.nombre"  
      :key="link.ruta"     
      class="nav-item"
      :class="[linksMode, link.mode, isMovil ? 'movil' : 'group']"
      :style="[isMovil ? link.style : '' ]"      
      @click="toggleClick(link)"  
    >
      <a 
        v-if="link.fullpath&&(link.clickMode != 'open')"
        :href="rooturl +'/'+ link.ruta"
        class="relative z-10"
        :class="[color1 ? link.color1 : link.color2]"
      >
        <!-- Link externo -->
        <font-icon 
          v-if="link.icon" 
          :icon="link.nombre" 
          class="w-10"        
        />
        <base-icon 
          v-else-if="link.baseicon"
          icon-name="iconIsotipoLogo"              
          class="inline-block"
          view-box="0 0 1940 1498"
          :width="[isMovil ? '100%' : '40px']"
          height="100%"
        >
          <icon-isotipo-logo :style="link.style" />
        </base-icon>
        <span 
          v-if="!link.baseicon&&!link.icon"
          class=" menu-span flex flex-col justify-center md:flex-row"
          v-html="link.nombre"
        >         
        </span>
      </a>  
      <router-link 
        v-if="!link.fullpath&&(link.clickMode != 'open')"
        :to="link.ruta"
        class="relative z-10"
        :class="[color1 ? link.color1 : link.color2]"
      >
        <!-- Link interno -->
        <font-icon 
          v-if="link.icon" 
          :icon="link.nombre" 
          class="w-10"   
        />
        <base-icon 
          v-else-if="link.baseicon"
          icon-name="iconIsotipoLogo"              
          class="inline-block"
          view-box="0 0 1940 1498"
          :width="[isMovil ? '100%' : '40px']"
          height="100%"
        >
          <icon-isotipo-logo :style="link.style" />
        </base-icon>
        <span 
          v-if="!link.baseicon&&!link.icon"
          class=" menu-span flex flex-col md:flex-row"
          v-html="link.nombre"
        >         
        </span>
      </router-link> 
      <div 
        v-else-if="link.clickMode == 'open'||link.clickModeMovil == 'open'"        
        :class="[isMovil ? 'justify-center flex cursor-pointer arrow-down' : 'cursor-pointer' ]"
      >
        <!-- No link submenu - movil -->
        <font-icon 
          v-if="link.icon" 
          :icon="link.nombre" 
          class="w-10"   
        />
        <span 
          v-else 
          class=" menu-span flex flex-col sm:flex-row"
          v-html="link.nombre"
        >         
        </span>
      </div>
      <base-sub-menu 
        v-if="link.submenu" 
        :id="`submenu-${link.nombre}`"
        :links="link.sublinks"
        :mode="link.submode"
        :class="[!link.visibility&&isMovil ? 'group-hover:inline-block hidden' : link.submodehover ]"
        @closeMenu="closeMenu"
      >
      </base-sub-menu>
    </div>
  </ul>
</template>

  <!--  linksMode: clases que se agregan a todos los links
        link.mode: clases del link
        link.style: estilo del link para movil
        link.fullpath: is true, es un link externo
        link.clickMode == 'open' - debe mostrarse el submenu y no ir a ningún lado en pc
        link.clickModeMovil == 'open' - debe mostrarse el submenu y no ir a ningún lado en movil
  -->

<script>
export default {
  props: {
    links: {
      type: Array,
      requiered: true,   
      default: () => []  
    },
    mode: {
      type: String,
      requiered: false, 
      default: ""  
    },
    linksMode: {
      type: String,
      requiered: false, 
      default: ""  
    },
    color1: {
      type: Boolean,
      requiered: false, 
      default: true  
    }
  },
  emits: ['close-menu'],
  data() {
    return {
      color: 'rgba(255, 66, 25, 1)' ,
    }
  },
  computed: {
    isMovil() {
      return this.$store.getters.getMovilView
    },
    rooturl(){
      return this.$store.getters.getRootURL
    }

  },
  methods: {
    toggleClick(link){      
      //console.log('click en un item ',link) 
      if (link.submenu){
        //console.log("submenu")
        if (this.isMovil) {
          //console.log('is movil')
          if (link.clickModeMovil == "open"){
            //console.log('open')
            const linkMenu = document.getElementById(`${link.nombre}`)
            const submenu = document.getElementById(`submenu-${link.nombre}`)
            //console.log(submenu)
            submenu.classList.toggle('visible')
            linkMenu.classList.toggle('open')
          } 
        } 
      } else if (link.fullpath){
        //console.log("link externo")
        this.$emit('close-menu', link);
      } else {
        //console.log("link interno")
        this.$emit('close-menu', link);
      }
    },
    closeMenu(link){
      //console.log("link submenu")
      this.$emit('close-menu', link);
    }
  },  

}
</script>

<style scoped>

/* .arrow-down::after{
  content: '▼';
}
.open .arrow-down::after{
  content: '▲';
} */
.blackback {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.vertical {
  display: flex;
  flex-direction: column;
}

/* .visible{
  display: inline-block !important;
  position: absolute;
  width: fit-content;
  text-align: center;
  background-color: white;
} */

.visible{
  display: inline-block !important;
  position: absolute;
  width: fit-content;
  text-align: center;
  border-top: 2px solid orange;
  font-size: 10px;
}

.movil .visible{
  position: relative; 
}

/* .visible .nav-sub-item{
  width: fit-content;
} */

.visible-sub-item{
  padding: 0px 1px !important;
}

  .not-hover {
    display: none !important;
  }
  @media screen and (min-width: 768px) {
    .menu-span{
      flex-direction: row;
      white-space: nowrap;
      justify-content: center; 
    }
  }


</style>
